(function ($, document, window) {
    'use strict';

    $(document).ready(function () {

        new ProductSearch();

        (function () {
            var
                $tabAdditionalServices = $('#tab-additional-services'),
                disableButtons = false;

            $tabAdditionalServices.on('click', '.add-addon-to-cart-on-product-page', function () {
                if (disableButtons) {
                    return false;
                }
            });

            if ($tabAdditionalServices.length) {
                $(document).on('cart/runCommand/success', function () {
                    var url = $tabAdditionalServices.data('url');

                    disableButtons = true;

                    var $modal = $('.modal');

                    $modal.on('hidden.bs.modal', function () {
                        $('> .product-addon-modal', 'body').remove();
                    });

                    $modal.modal('hide');

                    $.get(url).success(function (response) {
                        var $services = $(response.partials.tabs.header.services);

                        $tabAdditionalServices.find('.product-detail-service-item').each(function () {
                            var
                                $this = $(this),
                                addonId = $this.data('addon-id');

                            var $item = $services.find('.product-detail-service-item').filter(function () {
                                return $(this).data('addon-id') === addonId;
                            });

                            $this.html($item.html());

                            if( $this.hasClass('active') ) {
                                $this.find('.item-body').show();
                            }
                        });


                        $('.modal').each(function () {
                            $('body').append(this);
                        });

                        disableButtons = false;
                    });
                });
            }
        })();

        var $loginContainer = $('#login-container');

        $('#product-review-show-login-form').click(function (e) {
            $('#login-modal').modal();
            e.preventDefault();
        });

        LoginForm.register('#product-review-login', '#login-container', $loginContainer.attr('action'), {
            onAuth: function () {
                this.addMessage('success', 'Logging in. Please wait...').reloadPage(true);
            }
        });

        var $sliderContent = $('.slider-content');

        $sliderContent.lightSlider({
            mode: 'fade',
            gallery: true,
            item: 1,
            thumbItem: 6,
            slideMargin: 0,
            thumbMargin: 8,
            speed: 500,
            loop: true,
            freeMove: true,
            controls: false,
            onSliderLoad: function (el) {
                el.lightGallery({
                    selector: $sliderContent.find('.slider-item'),
                    addClass: 'lg-product-gallery lg-product-hero',
                    thumbContHeight: 177,
                    thumbWidth: 125,
                    thumbMargin: 16
                });
            },
            responsive: [
                {
                    breakpoint: 1182,
                    settings: {
                        thumbItem: 5,
                        thumbMargin: 8
                    }
                }
            ]
        });
        
        $('.screens-slider').lightGallery({
            selector: '.screens-slide a',
            addClass: 'lg-product-gallery',
            thumbContHeight: 100,
            thumbWidth: 100,
            thumbMargin: 5
        });
        
        function initSlider() {
            var $gallery = $('#product-gallery');
            if (!$gallery.length || $(window).width() >= 991) {
                return;
            }
            if ($gallery.hasClass('lightSlider') || $gallery.parent().hasClass('lSSlideWrapper')) {
                return;
            }
            $gallery.lightSlider({
                item: 2,
                slideMargin: 16,
                pager: false,
                prevHtml: '<i class="zmdi zmdi-arrow-left"></i>',
                nextHtml: '<i class="zmdi zmdi-arrow-right"></i>',
                responsive: [{
                    breakpoint: 579,
                    settings: { item: 1 }
                }]
            });
        }

        initSlider();

        $(window).on('resize', initSlider);

        
        $('.see-also').lightSlider({
            slideMargin: 16,
            pager: false,
            controls: false,
            item: 4,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        item: 3,
                        slideMargin: 8
                    }
                },
                {
                    breakpoint: 579,
                    settings: {
                        item: 2,
                        slideMargin: 8
                    }
                }
            ],
            onSliderLoad: function () {
                $('.see-also').closest('.lSSlideOuter').addClass('custom');
            }
        });

        $('.see-also .widget .widget-actions-mobile .btn').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.widget').toggleClass('w-actions-expanded');
        });

        // Change active tab on mobiles
        $(window).on('resize', function () {
            enquire.register("screen and (max-width: 767px)", {
                match: function () {
                    if(!window.location.hash) {window.location.hash = "screens"};
                }
            });
            enquire.register("screen and (min-width: 768px)", {
                match: function () {
                    if(!window.location.hash) {window.location.hash = "features"};
                }
            });
        });

        $(window).on('load', function () {
            enquire.register("screen and (max-width: 767px)", {
                match: function () {
                    if(!window.location.hash) {window.location.hash = "screens"};
                }
            });
        });
    });
    $(document).ready(function () {
        function attachReadMore(selector, step) {
            $(selector).on('click', function (e) {
                e.preventDefault();

                const $btn = $(this);
                const $tabPane = $btn.closest('.tab-pane');
                const $hiddenSections = $tabPane.find('.hidden-mobile');

                $hiddenSections.slice(0, step).removeClass('hidden-mobile');

                if ($tabPane.find('.hidden-mobile').length === 0) {
                    $btn.addClass('hidden');
                }
            });
        }

        attachReadMore('#read-more-btn-changelog', 5);
        attachReadMore('#read-more-btn-scenarios', 10);
        attachReadMore('#read-more-btn-reviews', 10);
    });
})(jQuery, document, window);
